type infoModalType = {
    modalIdx: string;
};

const state = (): infoModalType => ({
    modalIdx: "",
});

const getters = {
    getModalIdx(state: infoModalType): string {
        return state.modalIdx;
    },
};

const actions = {};

const mutations = {
    setModalIdx(state: infoModalType, modalIdx: string): void {
        state.modalIdx = modalIdx;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
